import { window } from "global";

export function getCookie(cname: string) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function addCookie(key: string, value: string, isSession?: boolean) {
  if (window) {
    if (isSession) {
      document.cookie = `${key}=${value}; path=/`;
    } else {
      document.cookie = `${key}=${value}; expires=Thu, 01-Jan-2100 00:00:01 GMT; path=/`;
    }
  }
}

export function addCookieWithExpiration(key: string, value: string, expirationDays: number, domain?: string) {
  if (window) {
    const date = new Date();
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    const domainPart = domain ? `; domain=${domain}` : "";
    document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/${domainPart}`;
  }
}

export function removeCookie(key: string, domain?: string) {
  if (window) {
    const domainPart = domain ? `; domain=${domain}` : "";
    document.cookie = `${key}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/${domainPart}`;
  }
}
